import Mutations from '../../odata/mutations';

export default { ...new Mutations('candidateDocument'), ...new Mutations('candidateDocuments') };
